let mapsPromise = null;

const loadGoogleMaps = () => {
  if (mapsPromise) {
    return mapsPromise;
  }

  if (window.google && window.google.maps) {
    mapsPromise = Promise.resolve();
    return mapsPromise;
  }

  mapsPromise = new Promise((resolve, reject) => {
    // With loading=async, the script's own onload fires before google.maps
    // sub-namespaces (e.g. OverlayView, used by snazzy-info-window) are
    // necessarily populated - the callback param is Google's documented way
    // to know the API is actually ready in this loading mode.
    window.__onGoogleMapsLoaded = resolve;

    const script = document.createElement('script');
    script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyAAj5BgzyLR879nUDDG6-9uPLPBrleZkFA&loading=async&callback=__onGoogleMapsLoaded';
    script.onerror = reject;
    document.head.appendChild(script);
  });

  return mapsPromise;
};

export default loadGoogleMaps;
